import PropTypes from 'prop-types';

const ImageGallerySection = ({ title, images, backgroundColor = 'var(--primary-color)' }) => {
  return (
    <section
      style={{ backgroundColor }}
      className="py-16 md:py-20 relative overflow-visible pb-4 md:pb-8"
    >
      <div className="container mx-auto px-4 pt-12 md:pt-16 lg:pt-20">
        {/* Title */}
        <div className="text-center mb-24 md:mb-32 lg:mb-38">
          <h2 className="font-bold text-white leading-tight max-w-4xl mx-auto px-4">
            {title}
          </h2>
        </div>

        {/* Images Container */}
        <div className="max-w-7xl mx-auto">
          {/* Desktop & Tablet Layout - All 4 images in a row with alignment */}
          <div className="hidden md:flex items-end justify-center gap-4 lg:gap-6 relative">
            {images.map((image, index) => (
              <div
                key={index}
                className={`flex-shrink-0 ${
                  index === 0 ? 'md:w-[20%] lg:w-[21%]' :
                  index === 1 ? 'md:w-[20%] lg:w-[21%]' :
                  index === 2 ? 'md:w-[20%] lg:w-[21%]' :
                  'md:w-[20%] lg:w-[21%]'
                }`}
                style={
                  index === 0 ? { marginBottom: '-28px' } :
                  index === 1 ? { marginBottom: '-10px' } :
                  index === 2 ? { marginBottom: '-70px' } :
                  index === 3 ? { marginBottom: '-10px' } : {}
                }
              >
                <div className="rounded-lg overflow-hidden shadow-2xl">
                  <img
                    src={image.src}
                    alt={image.alt || `Gallery image ${index + 1}`}
                    className={`w-full object-cover ${
                      index === 0 ? 'h-50 md:h-58 lg:h-60' :
                      index === 1 ? 'h-30 md:h-38 lg:h-46' :
                      index === 2 ? 'h-70 md:h-72 lg:h-80' :
                      'h-42 md:h-48 lg:h-52'
                    }`}
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Mobile Layout - Single Column */}
          <div className="flex md:hidden flex-col gap-6 max-w-sm mx-auto">
            {images.map((image, index) => (
              <div key={index} className="rounded-lg overflow-hidden shadow-2xl">
                <img
                  src={image.src}
                  alt={image.alt || `Gallery image ${index + 1}`}
                  className="w-full h-64 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

ImageGallerySection.propTypes = {
  title: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
    })
  ).isRequired,
  backgroundColor: PropTypes.string,
};

export default ImageGallerySection;